import React, { useState } from 'react';
import { Box } from '@mui/material';
import { PhotoCamera as PhotoCameraIcon } from '@mui/icons-material';
import { resolveImageUrl } from '../utils/imageUrl';

interface ProductImageProps {
    imageUrl?: string | string[];
    name: string;
    size?: number;
    className?: string;
}

export const ProductImage: React.FC<ProductImageProps> = ({ imageUrl, name, size = 40, className }) => {
    const [error, setError] = useState(false);
    const resolvedUrl = resolveImageUrl(imageUrl);

    if (!resolvedUrl || error) {
        return (
            <Box
                className={className}
                sx={{
                    width: size,
                    height: size,
                    backgroundColor: '#f3f4f6',
                    borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid #ddd',
                    flexShrink: 0
                }}
            >
                <PhotoCameraIcon sx={{ color: '#9ca3af', fontSize: Math.max(16, size / 2) }} />
            </Box>
        );
    }

    return (
        <Box
            component="img"
            src={resolvedUrl}
            alt={name}
            className={className}
            onError={() => setError(true)}
            sx={{
                width: size,
                height: size,
                objectFit: 'cover',
                borderRadius: 1,
                border: '1px solid #ddd',
                flexShrink: 0
            }}
        />
    );
};
